<template>
  <div class="demand">
    <div class="content">
      <div class="nav flex">
        当前位置：
        <el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="javascript:void(0);">需求登记</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form :model="form" :rules="err" ref="form" label-width="120px" class="form">
        <el-form-item label="选择回馈机构：">
          <ThreeLink :show_level="false" codeType="provinceid" dictValue="p20" codeLevel="-1" classed="classed" :changeonselect="'true'" placeholder="请选省市区残联" class="width100"
            @setMValue="setScasValue($event,form,['province','city','three'])" :defaultValue="[form.province,form.city,form.three]"></ThreeLink>
        </el-form-item>
        <el-form-item label="需求类型：">
          <el-radio-group v-model="form.needsType">
            <el-radio-button label="系统操作类"></el-radio-button>
            <el-radio-button label="招聘类"></el-radio-button>
            <!-- <el-radio-button label="机构培训"></el-radio-button>
            <el-radio-button label="课件学习"></el-radio-button>
            <el-radio-button label="就业"></el-radio-button>
            <el-radio-button label="创业"></el-radio-button>
            <el-radio-button label="其他"></el-radio-button> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="期望时间：">
          <el-date-picker v-model="form.expectTime" type="date" value-format="yyyy/MM/dd" popper-class="eagle-a11y-uncut" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="需求内容：">
          <el-input v-if="form.needsType =='系统操作类'" type="textarea" :rows="8" placeholder="请输入内容" v-model="form.needsContent">
          </el-input>
          <template v-else>
            <!-- userType -->
            <disJobForm  ref="disJobForm"/>
          </template>
          <!-- <Editor placeholder="请输入内容" @html="text" class="width100" v-model="form.needsContent"></Editor> -->
        </el-form-item>
        <el-form-item label="" label-width="0" class="buttons">
          <el-button type="primary" class="btn" @click="save('form')">提交需求</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import MulSelect from '@/components/selectComponents/MulSelect';
import ThreeLink from '@/components/selectComponents/ThreeLink';
import Editor from 'components/public/editor';
import companyJobForm from './components/companyJobForm.vue';
import disJobForm from './components/disJobForm.vue';
export default {
  name: 'index',
  components: {
    MulSelect,
    ThreeLink,
    Editor,
    companyJobForm,
    disJobForm
  },
  data() {
    return {
      userType: '',
      form: {
        province: '',
        city: '',
        three: '',
        needsType: '系统操作类',
        expectTime: '',
        needsContent: ''
      },
      err: {
        needsType: [
          {
            required: true,
            message: '请选择需求类型',
            trigger: 'change'
          }
        ]
      }
    };
  },
  methods: {
    save(form) {
      if (!this.form.needsType) {
        this.$message.error('请选择需求类型');
        return;
      }
      if (!this.form.expectTime) {
        this.$message.error('请选择期望时间');
        return;
      }
      if (this.form.needsType == '系统操作类') {
        if (!this.form.needsContent) {
          this.$message.error('请选择需求内容');
          return;
        }
      }
      if(this.form.needsType == '招聘类'){
        this.$refs['disJobForm'].handleSave();
      }
      this.$refs[form].validate(async valid => {
        if (valid) {
          let res = await this.$api.addNeed(this.form);
          if (res.data.success) {
            this.$message.success('需求添加成功');
          } else {
            this.$message.error(res.message);
          }
        }
      });
    },
    setScasValue(event, form, keys) {
      for (let i = 0; i < keys.length; i++) {
        let value = event[i];
        if (!value) {
          value = '';
        }
        let key = keys[i];
        form[key] = value;
      }
    },
    text(val) {
      this.form.needsContent = val;
    }
  },
  mounted() {
    let login = JSON.parse(localStorage.getItem('userInfo') || null);
    if (login) {
      this.memberId = login.id;
      this.userType = login.userType;
    }
  }
};
</script>

<style scoped lang="less">
.demand {
  background: white;
  .content {
    width: 1200px;
    margin: 0 auto;
    .nav {
      padding-top: 20px;
      color: #6d6d6d;
      /deep/ .el-breadcrumb {
        margin-top: 2px;
      }
      a {
        color: #6d6d6d;
      }
    }
    .form {
      width: 900px;
      margin: 0 auto;
      padding: 70px 0;
      .buttons {
        text-align: center;
        .btn {
          width: 288px;
          height: 44px;
          margin-top: 30px;
        }
      }
    }
  }
}
</style>